import React from 'react';
import { useNavigate } from 'react-router';
import styles from './ActivationGuides.module.scss';

interface StoreGuide {
  id: string;
  name: string;
  thumbnail: string;
  description: string;
}

const ActivationGuides: React.FC = () => {
  const navigate = useNavigate();

  const storeGuides: StoreGuide[] = [
    {
      id: 'steam',
      name: 'Steam',
      thumbnail: `${process.env.PUBLIC_URL}/images/activation-guides/steam.png`,
      description: 'Learn how to activate your Steam gift cards and game keys'
    },
    {
      id: 'riot-games',
      name: 'Riot Games',
      thumbnail: `${process.env.PUBLIC_URL}/images/activation-guides/Riot_Games.png`,
      description: 'Step-by-step guide to redeem Riot Points and Valorant Points'
    },
    {
      id: 'ea-play',
      name: 'EA Play',
      thumbnail: `${process.env.PUBLIC_URL}/images/activation-guides/EA_play.png`,
      description: 'Activate EA Play gift cards and Origin wallet funds'
    },
    {
      id: 'epic-games',
      name: 'Epic Games',
      thumbnail: `${process.env.PUBLIC_URL}/images/activation-guides/Epic_Games.png`,
      description: 'Redeem Epic Games Store gift cards and wallet funds'
    },
    {
      id: 'ubisoft-connect',
      name: 'Ubisoft Connect',
      thumbnail: `${process.env.PUBLIC_URL}/images/activation-guides/Ubisoft_Connect.png`,
      description: 'Activate Ubisoft Connect credits and game keys'
    },
    {
      id: 'rockstar-social-club',
      name: 'Rockstar Social Club',
      thumbnail: `${process.env.PUBLIC_URL}/images/activation-guides/R_social_club.png`,
      description: 'Redeem Rockstar Games gift cards and in-game currency'
    },
    {
      id: 'gog',
      name: 'GOG.com',
      thumbnail: `${process.env.PUBLIC_URL}/images/activation-guides/gog_dotcom.png`,
      description: 'Activate GOG.com gift cards and game codes'
    }
  ];

  const handleStoreClick = (storeId: string) => {
    navigate(`/activation-guides/${storeId}`);
  };

  const handleBackToStore = () => {
    navigate('/');
  };

  const handleShippingDeliveryClick = () => {
    navigate('/shipping-and-delivery');
  };

  return (
    <div className={styles.activationGuides}>
      <div className={styles.container}>
        <div className={styles.header}>
          <button 
            className={styles.backButton}
            onClick={handleBackToStore}
          >
            <img 
              src={`${process.env.PUBLIC_URL}/images/icons/back-arrow.svg`}
              alt="Back"
            />
            Back to Store
          </button>
          <button 
            className={styles.shippingLink}
            onClick={handleShippingDeliveryClick}
          >
            <span className={styles.shippingIcon}>📦</span>
            <span className={styles.shippingText}>Shipping & Delivery Policy</span>
            <span className={styles.shippingArrow}>→</span>
          </button>
          <div className={styles.headerContent}>
            <h1 className={styles.title}>Activation Guides</h1>
            <p className={styles.subtitle}>
              Choose your store platform to view step-by-step activation instructions
            </p>
          </div>
        </div>

        <div className={styles.storeGrid}>
          {storeGuides.map((store) => (
            <div 
              key={store.id}
              className={styles.storeCard}
              onClick={() => handleStoreClick(store.id)}
            >
              <div className={styles.thumbnailContainer}>
                <img 
                  src={store.thumbnail}
                  alt={store.name}
                  className={styles.thumbnail}
                  onError={(e) => {
                    const target = e.currentTarget as HTMLImageElement;
                    target.onerror = null;
                    target.src = `${process.env.PUBLIC_URL}/images/store-desktop-thumbnail.png`;
                  }}
                />
                <div className={styles.overlay}>
                  <span className={styles.viewGuide}>View Guide</span>
                </div>
              </div>
              <div className={styles.storeInfo}>
                <h3 className={styles.storeName}>{store.name}</h3>
                {/* <p className={styles.storeDescription}>{store.description}</p> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActivationGuides; 